export const agentFieldMapping = {
  LIST_AGENT_KEY: 'MemberKey',
  LIST_AGENT_FULL_NAME: 'MemberFullName',
  LIST_AGENT_FIRST_NAME: 'MemberFirstName',
  LIST_AGENT_LAST_NAME: 'MemberLastName',
  LIST_AGENT_EMAIL: 'MemberEmail',
  LIST_AGENT_MLS_ID: 'MemberMlsId',
  LIST_AGENT_CELL_PHONE: 'MemberMobilePhone',
  LIST_AGENT_DIRECT_PHONE: 'MemberDirectPhone',
  LIST_OFFICE_KEY: 'OfficeKey',
  LIST_OFFICE_NAME: 'OfficeName',
  LIST_OFFICE_PHONE: 'MemberOfficePhone',
  LIST_OFFICE_MLS_ID: 'OfficeMlsId',
  LIST_AGENT_STATE_LICENSE_NUMBER: 'MemberStateLicense',
};
